/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFilePpt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4zm11 3.414V7h1.586z" />
        <path d="M9.77 17v-4.87h1.741c.599 0 1.05.138 1.354.415.308.276.462.687.462 1.232 0 .54-.154.952-.462 1.233-.304.277-.755.415-1.354.415h-.703V17zm1.527-4.02h-.49v1.595h.49c.357 0 .61-.06.757-.181.152-.125.228-.33.228-.617 0-.29-.076-.495-.228-.616-.147-.12-.4-.181-.757-.181zM13.97 17v-4.87h1.742c.598 0 1.05.138 1.353.415.308.276.462.687.462 1.232 0 .54-.154.952-.462 1.233-.304.277-.755.415-1.353.415h-.704V17zm1.527-4.02h-.489v1.595h.49c.357 0 .61-.06.756-.181.152-.125.228-.33.228-.617 0-.29-.076-.495-.228-.616-.147-.12-.4-.181-.757-.181zM19.29 17v-3.986h-1.44v-.885h3.927v.885h-1.44V17z" />
      </g>
    </g>
  </Icon>
);
export { SvgFilePpt as FilePpt };
